import { useState } from "react";
import Button from "@/components/Button";
import Banner from "@/components/Banner";
import useModal from "@/hooks/useModal";

interface Props {
  onConfirm: () => Promise<boolean>;
  onClosed: () => void;
}

export default function DeleteCommentModal({ onConfirm, onClosed }: Props) {
  const { Modal, close } = useModal();
  const [loading, setLoading] = useState(false);
  const [bannerError, setBannerError] = useState("");

  const handleDelete = async () => {
    setLoading(true);
    setBannerError("");
    try {
      const success = await onConfirm();
      if (success) {
        close();
      } else {
        setBannerError("The comment could not be deleted. Please try again.");
      }
    } catch {
      setBannerError("The comment could not be deleted. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const action = (
    <Button theme="error" icon="delete" disabled={loading} onClick={handleDelete} testId="delete-comment-confirm">
      Delete
    </Button>
  );

  return (
    <Modal action={action} onClosed={onClosed} headline="Delete Comment" hasFormElements={false} className="w-[490px]">
      {!!bannerError && (
        <div className="mb-6">
          <Banner inline variant="error" description={bannerError} />
        </div>
      )}
      <p>Are you sure you want to delete this comment? This action cannot be undone.</p>
    </Modal>
  );
}
